// extracted by mini-css-extract-plugin
module.exports = {"root":"root-1hWnt","carry_on":"carry_on-ejEuO","wrapper":"wrapper-Egrkj","value":"value-1r3pi","measurement":"measurement-BwJv_"};